module.exports = __webpack_public_path__ + "static/Photonics-f0d320afb51cf51e57dc3e86d76cd340.png";